export default __webpack_public_path__ + "static/media/laundry2-before-768w.9041c7d6.webp";